import { $ } from '../$.js';
import { data } from '../functions/data.js';
$.data = data;
